import { configureStore } from "@reduxjs/toolkit";
import cubeReducer from "../features/cube/cubeSlice";
import queryReducer from "../features/cube/querySlice";
import resultsReducer from "../features/cube/resultsSlice";
import authReducer from "../features/auth/authSlice";

// Les contrôles de dev de Redux Toolkit parcourent tout l'état à chaque action :
// avec un résultat de cube de plusieurs dizaines de milliers de lignes, chaque
// action gelait l'onglet. Le résultat (données brutes, jamais muté) en est exclu.
const LARGE_PATHS = ["results.data"];

export const store = configureStore({
  reducer: {
    cube: cubeReducer,
    query: queryReducer,
    results: resultsReducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: { ignoredPaths: LARGE_PATHS },
      serializableCheck: { ignoredPaths: LARGE_PATHS },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
